import {XauditModel} from '../../../../models/xaudit.model';
import {AnesthesiaEndoExplosionItemConfigurationModel} from './anesthesia-endo-explosion-item-configuration.model';

export class AnesthesiaEndoExplosionConfigurationModel extends XauditModel {
  AnesthesiaEndoExplosionID: string;
  Name: string;

  cfgAnesthesiaEndoExplosionItems: AnesthesiaEndoExplosionItemConfigurationModel[];
}
